import { Flex, Tooltip, Typography } from "antd"
import React from "react"

import { cn } from "../../../utils/cn.ts"
import { type PermissionsMode } from "../types.ts"
import type {
  AnyPermissionKey,
  PermissionDisplayMap,
  PermissionFeatures
} from "../types/permissions.types.ts"
import { PermissionsActionSwitch } from "./PermissionsActionSwitch.tsx"

const { Text } = Typography

type PermissionsFeatureRowProps = {
  parentKey: keyof PermissionFeatures
  subKey?: string
  featureKey: string
  value: boolean | undefined
  idx: number
  isUpdating?: boolean
  displayMap?: PermissionDisplayMap | null
} & PermissionsMode

export const PermissionsFeatureRow = ({
  parentKey,
  subKey = "features",
  featureKey,
  value,
  idx,
  isUpdating,
  displayMap,
  ...rest
}: PermissionsFeatureRowProps) => {
  const meta = displayMap?.[featureKey as AnyPermissionKey]
  const modeProps: PermissionsMode = rest?.asForm
    ? { asForm: true }
    : { onItemChange: rest?.onItemChange }

  return (
    <Flex
      align="center"
      justify="space-between"
      gap={8}
      className={cn(
        "py-1 px-4 border-border border-b",
        idx % 2 === 0 && "border-r"
      )}
    >
      <Tooltip title={meta?.tooltip}>
        <Text className={"capitalize"}>
          {meta?.name ?? featureKey.replace(/_/g, " ")}
        </Text>
      </Tooltip>

      <PermissionsActionSwitch
        parentKey={parentKey}
        displayMap={displayMap}
        subKey={subKey}
        actionKey={featureKey}
        value={value ?? false}
        isUpdating={isUpdating}
        {...modeProps}
      />
    </Flex>
  )
}
